module.exports = __webpack_public_path__ + "static/media/grid.4ea14032.svg";